import { useState } from "react";
import { createContainer } from "unstated-next";

function useCurrentApplicationContainer() {
    const [currentApplicationId, setCurrentApplicationId] = useState<string | null>(null);

    const setApplicationId = (applicationId: string | null) => {
        setCurrentApplicationId(applicationId);
    };

    const clearApplicationId = () => {
        setCurrentApplicationId(null);
    };

    return {
        currentApplicationId,
        setApplicationId,
        clearApplicationId
    };
}

const CurrentApplicationContainer = createContainer(useCurrentApplicationContainer);
export default CurrentApplicationContainer;
